export const BIRTH_DAY = 'birth_day';
export const BIRTH_MONTH = 'birth_month';
export const BIRTH_YEAR = 'birth_year';
